import { createAsyncThunk } from "@reduxjs/toolkit";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';


import {
  getRows as getRowsEndpoint,
  getVehicles as getVehiclesPagedEndpoint,
  getVehicle as getVehicleEndpoint,
  addVehicle as addVehicleEndpoint,
  updateVehicle as updateVehicleEndpoint,
  addVehicleImages as addVehicleImagesEndpoint,
  publishVehicle as publishVehicleEndpoint
} from "../../helpers/fakebackend_helper";

export const publishVehicle = createAsyncThunk("vehicle/publishVehicle", async (vehicleId) => {
  try {
    return publishVehicleEndpoint(vehicleId);
  } catch(error) {
    return error;
  }
});

export const getRows = createAsyncThunk("vehicle/getRows", async (request) => {
  try {
    return getRowsEndpoint(request);
  } catch (error) {
      return error;
  }
});

export const getVehicles = createAsyncThunk("vehicle/getVehicles", async (request) => {
  try {
    return getVehiclesPagedEndpoint(request);
  } catch (error) {
      return error;
  }
});

export const getVehicle = createAsyncThunk("vehicle/getVehicle", async (vehicleId) => {
  try {
    return getVehicleEndpoint(vehicleId);
  } catch (error) {
      return error;
  }
});

export const addVehicle = createAsyncThunk("vehicle/addVehicle", async (vehicle) => {
  try {
    const data = await addVehicleEndpoint(vehicle);;
    toast.success("Vozilo uspješno dodano!", { autoClose: 3000 });
    return data;
  } catch (error) {
    toast.error("Dodavanje vozila neuspješno!", { autoClose: 3000 });
    return error;
  }
});

export const updateVehicle = createAsyncThunk("vehicle/updateVehicle", async (vehicle) => {
  try {
    const data = await updateVehicleEndpoint(vehicle);
    toast.success("Vozilo uspješno ažurirano!", { autoClose: 3000 });
    return data;
  } catch (error) {
    toast.error("Ažuriranje vozila neuspješno!", { autoClose: 3000 });
    return error;
  }
});

export const addVehicleImages = createAsyncThunk("vehicle/updateVehicleImages", async (images) => {
  try {
    const data = await addVehicleImagesEndpoint(images);
    toast.success("Slike uspješno dodane!", { autoClose: 3000 });
    return data;
  } catch (error) {
    toast.error("Dodavanje slika neuspješno!", { autoClose: 3000 });
    return error;
  }
});